module.exports = __webpack_public_path__ + "media/images/home/icon-close-bbde3ef712f57330196ba21d115608f6.svg";